import { BaseButtonStyledProps } from "../types";
import { getButtonHeight } from "./getButtonHeight";
import { mapButtonAppearance } from "./mapButtonAppearance";

export const getButtonMinWidth = (props: BaseButtonStyledProps) => {
    const { hasNoIcons, appearance, themeMode } = props;
    const actualAppearance = mapButtonAppearance(appearance, themeMode);

    switch (actualAppearance) {
        // In Lodestar, Only non-borderless buttons with no icons have a min width
        case "borderless":
        case "link":
            // 'auto' here means "don't set a min width".
            return "auto";
        case "primary":
        case "secondary":
        case "destructive":
        case "secondary-destructive":
        case "share":
            if (hasNoIcons) {
                return "96px";
            } else {
                return "auto";
            }
        // For Ursa buttons.
        case "primary-filled":
        case "primary-empty":
        case "secondary-filled":
        case "secondary-outlined":
        case "secondary-empty":
        case "canvas-filled":
        case "canvas-empty":
        case "destructive-filled":
        case "destructive-empty":
            return `${getButtonHeight(props)}px`;
        default:
            return "auto";
    }
};
